<template>
  <!-- 暂时没有用到，定投没问题后可删除 2022-04-01-->
  <div>
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">{{sign? '恒宝宝定期定额充值开通':'定期定额基金买入'}}</span>
      </el-row>
      <div style="width:935px;margin:20px auto;">
        <div class="d-alert">确认信息</div>
        <p class="tips">您确定要进行以下交易吗？确定请点击“转到银行签订协议”，并完成转到银行签订协议操作，否则将自动作废。</p>

        <el-form :model="tableForm" class="table-normal-form">
          <table class="table-normal-one margin-t15" cellspacing="0">
            <tbody>
              <tr>
                <td style="width:145px;">协议号</td>
                <td style="width:310px;">{{fundMessage.success.buyplanno}}</td>
                <td></td>
              </tr>
              <tr>
                <td>{{sign? '产品名称':'基金名称'}}</td>
                <td><span class="aColor">{{sign? '恒宝宝':fundMessage.form.name}}</span></td>
                <td></td>
              </tr>
              <tr>
                <td style="width:145px;">银行卡类型</td>
                <td style="width:310px;">{{fundMessage.bank.moneyaccount}}</td>
                <td></td>
              </tr>
              <tr>
                <td style="width:145px;">首次扣款日期</td>
                <td style="width:310px;">{{$commonJs.getDateStrHz(fundMessage.success.firstinvestdate)}}</td>
                <td></td>
              </tr>
              <tr>
                <td>定投金额</td>
                <td>{{fundMessage.form.price + '元'}}</td>
                <td><span class="rColor" id="capital"></span></td>
              </tr>
              <tr>
                <td style="width:145px;">投资周期</td>
                <td style="width:310px;">{{fundMessage.investperiodsvaluedesc}}</td>
                <td></td>
              </tr>
              <tr>
                <td style="width:145px;">证件类型</td>
                <td style="width:310px;">{{documentType}}</td>
                <td></td>
              </tr>
              <tr>
                <td>证件号码</td>
                <td>
                  <el-radio-group v-model="tableForm.zihm" class="radio-single-one">
                    <el-radio :label="18">{{this.fundMessage.bank.certId18vByConfusion+'（18位）'}}</el-radio><br>
                    <el-radio :label="15">{{this.fundMessage.bank.certId15vByConfusion+'（15位）'}}</el-radio>
                  </el-radio-group>
                </td>
                <td><span class="warnColor">*如果为身份证,请确认显示位数与签订协议的银行卡身份证位数是否一致(18位/15位)</span></td>
              </tr>
              <tr>
                <td></td>
                <td colspan="2">
                  <el-button v-show="!sendAuthCode" type="normal" @click="turn">转到银行签订协议</el-button>
                  <el-button v-show="sendAuthCode" type="normal" @click="rebackTwo">返回</el-button>
                  <span v-show="!sendAuthCode" class="margin-l10">请在{{time}}秒内点击上面的按钮</span>
                  <span v-show="sendAuthCode" class="margin-l10">{{warn}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form>
      </div>
      <!-- 说明 -->
      <section class="instruction margin-t70">
        <div class="instruction-li">
          <p class="instruction-li-title">温馨提示</p>
          <p class="instruction-li-con">
            根据我司《定期定额业务规则》，如果您选择本工作日为扣款日，系统将于下一个工作日首次产生定期定额扣款流水业务申请。<br>
            通过工行卡开通我公司基金定投的客户，需要在工行页面签约成功之后，在本页面点击“下一步”，确保定投协议签订成功。
          </p>
        </div>
      </section>
    </div>
    <!-- 对话框 -->
    <el-dialog class="dialog-single-tips" title="系统提示：" :visible.sync="successDialogVisable" :show-close="false">
      <p class="dialog-single-tips-tit">定期定额申购协议开通成功</p>
      <div class="dialog-single-tips-con">
        您的交易委托已经受理，<br>
        协议号为：<strong class="rColor">{{fundMessage.success.buyplanno}}</strong> <br>
        该笔交易成功与否将以基金公司确认为准，请您及时查询<br>
        委托内容：{{sign? '恒宝宝':fundMessage.form.name}}<br>
        定投金额：<strong class="rColor">{{fundMessage.form.price + '元'}}</strong>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="openSuccess">确定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
export default {
  data () {
    return {
      tableForm: {
        zihm: 18,
      },
      // 转
      time: 118,
      sendAuthCode: true,
      warn: '您没有在限定的时间内转去银行签订协议，为了安全起见该笔协议已被禁止。',
      successDialogVisable: false,
      // 跳转参数
      fundMessage: '',
      sign: false,
      documentType: '',//证件类型
    }
  },
  created () {
    this.sign = this.$route.params.sign
    this.fundMessage = this.$route.params
    // console.log(this.fundMessage);
    this.documentType = this.$parameterConfig.p_certificatetype[this.fundMessage.bank.certificatetype]
  },
  mounted () {
    this.countDown()
    this.$commonJs.amountWords(this.fundMessage.form.price, 'capital')

  },
  methods: {
    countDown () {
      this.sendAuthCode = false;
      var timetimer = setInterval(() => {
        if (this.time == 0) {
          this.sendAuthCode = true;
          clearInterval(timetimer);
          this.codefont = 1
        } else {
          this.time--;
        }
      }, 1000);
    },
    // 转到银行签订协议
    turn () {
      this.$http.post(this.$apiPath.signSend, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        saveplanno: this.fundMessage.success.buyplanno,
        moneyaccount: this.fundMessage.bank.moneyaccount,
        applicationamount: this.fundMessage.form.price,
        fundname: this.fundMessage.fund.fundname,
        certIdLength: this.tableForm.zihm,
        fundcode: this.fundMessage.fund.fundcode,
        appsheetserialno: this.fundMessage.success.appsheetserialno,
        firstinvestdate: this.fundMessage.success.firstinvestdate,
        channelid: this.fundMessage.bank.channelid
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.successDialogVisable = true
        // 推送消息
        this.$store.dispatch({
          type: "pushNews",
          index: 9,
          fundname: this.fundMessage.fund.fundname,
          money: this.fundMessage.form.price,
          dtDate: this.fundMessage.investperiodsvaluedesc,
          fundname2: ''
        })
        // console.log(res);
      }).catch(err => { })

    },
    rebackTwo () {
      if (this.sign) {
        this.$router.push({ name: 'fixedInvestment' })
      } else {
        this.$router.push({
          name: 'fixedManagement',
          params: {
            active: '2'
          }
        })
      }
    },
    openSuccess () {
      this.successDialogVisable = false
      if (this.sign) {
        this.$router.push({ name: 'fixedInvestment' })
      } else {
        this.$router.push({
          name: 'fixedManagement',
          params: {
            active: '2'
          }
        })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.tips {
  color: @rColor;
  margin: 15px;
}
</style>